import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        display: block;\n        border-radius: ", ";\n\n        width: ", ";\n        height: ", ";\n\n        ", "\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-image: linear-gradient(\n        90deg,\n        ", " 0px,\n        ", " 20px,\n        ", " 40px\n    );\n    background-size: calc(", " + 40px);\n    animation: ", " ", "s infinite linear;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background-image: linear-gradient(\n        90deg,\n        ", " 0px,\n        ", " 20px,\n        ", " 40px\n    );\n    background-size: calc(", " + 40px);\n    animation: ", " ", "s infinite linear;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    0% {\n        background-position: -40px;\n    }\n\n    40%,\n    100% {\n        background-position: ", ";\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    0% {\n        background-position: -40px;\n    }\n\n    40%,\n    100% {\n        background-position: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css, keyframes } from 'styled-components';

var shine = function shine(props) {
  return keyframes(_templateObject(), props.width);
};

var shineCircle = function shineCircle(props) {
  return keyframes(_templateObject2(), props.width);
};

export var StyledCircleSkeleton = function StyledCircleSkeleton(props) {
  return css(_templateObject3(), props.background || props.theme.components.skeleton.background, props.shineBackground || props.theme.components.skeleton.shineBackground, props.background || props.theme.components.skeleton.background, props.width, shineCircle, props.duration);
};
export var StyledDefaultSkeleton = function StyledDefaultSkeleton(props) {
  return css(_templateObject4(), props.background || props.theme.components.skeleton.background, props.shineBackground || props.theme.components.skeleton.shineBackground, props.background || props.theme.components.skeleton.background, props.width, shine, props.duration);
};
export var StyledSkeleton = styled.span(_templateObject5(), function (props) {
  return css(_templateObject6(), props.circle ? '50%' : '4px', props.width, props.height, props.circle ? StyledCircleSkeleton(props) : StyledDefaultSkeleton(props));
});